const GET_PROFILE = 'getProfile';
const GET_INSTALLATION = 'getInstallation';

const RESET = 'reset';

const defaultState = () => ({
  user: {
    isFetching: false,
    address: null,
    email: null,
    pchn: null,
    phone: null,
    streetViewUrl: null,
    tenant: null,
    housingCooperative: {
      logoUrl: null,
      name: null,
    },
  },
  fetchError: null,
  installation: {
    isFetching: false,
    installationType: null,
    lastReport: null,
    locationPanels: null,
    numberOfPanels: null,
  },
});

export default {
  namespaced: true,

  state: defaultState(),

  /* eslint-disable no-param-reassign */
  mutations: {
    [`${GET_PROFILE}+pending`]: (state) => {
      state.user.isFetching = true;
    },

    [`${GET_PROFILE}+success`]: (state, { payload }) => {
      Object.assign(state.user, payload.tenant);
      state.user.isFetching = false;
    },

    [`${GET_PROFILE}+rejected`]: (state, { payload }) => {
      state.authenticationError = payload.message;
      state.user.isFetching = false;
    },

    [`${GET_INSTALLATION}+pending`]: (state) => {
      state.installation.isFetching = true;
    },

    [`${GET_INSTALLATION}+success`]: (state, { payload }) => {
      Object.assign(state.installation, payload);
      state.installation.isFetching = false;
    },

    [`${GET_INSTALLATION}+rejected`]: (state, { payload }) => {
      state.installation.isFetching = false;
      state.fetchError = payload.message;
    },

    [RESET]: (state) => {
      Object.assign(state, defaultState());
    },
  },
  /* eslint-disable no-param-reassign */

  actions: {
    async [GET_PROFILE]({ dispatch, commit }) {
      const profile = await this.$bind({ commit }, GET_PROFILE).with(
        this.$axios.get('/users/profile'),
      );

      await dispatch('account/setAdmin', profile.user.isAdmin, { root: true });

      return profile;
    },

    [GET_INSTALLATION](store) {
      return this.$bind(store, GET_INSTALLATION).with($api => $api.get('/users/installation'));
    },
  },
};
